<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage" style="margin-right: 20px">
    <div>
      <i class="el-icon-arrow-down el-icon--right"></i>
      <!--<svg-icon class-name="international-icon" icon-class="language" />-->
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='zh'" command="zh">中文</el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en">English</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import en from '@/lang/en' // Internationalization
  import zh from '@/lang/zh' // Internationalization
  import i18n from '@/lang'
  import Cookie from 'js-cookie'
  export default {
    computed: {
      language() {
        return this.$store.getters.language
      }
    },
    created() {
      let lang = Cookie.get('language') ? Cookie.get('language'):'zh'
      if(lang === 'en'){
        i18n.vm.messages['en'] = en
        this.$store.dispatch('setLanguage', 'en')
      } else {
        i18n.vm.messages['zh'] = zh
        this.$store.dispatch('setLanguage', 'zh')
      }
    },
    methods: {
      handleSetLanguage(lang) {
        let langs = Cookie.get('language') ? Cookie.get('language'):'zh'
        if(lang === 'en'){
          i18n.vm.messages['en'] = en
          this.$store.dispatch('setLanguage', 'en')
          this.$message({
            message: 'Switch Language Success',
            type: 'success'
          })
        } else {
          i18n.vm.messages['zh'] = zh
          this.$store.dispatch('setLanguage', 'zh')
          this.$message({
            message: 'Switch Language Success',
            type: 'success'
          })
        }
        location.reload();
      }
    }
  }
</script>

<style scoped>
  .international-icon {
    font-size: 20px;
    cursor: pointer;
    vertical-align: -5px!important;
  }
</style>

